import { any } from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import store from 'store'
import { toggleSidebar } from 'store/ui'
import Header from './Header/index'
import LayoutWrapper from './LayoutWrapper'
import Sidebar from './Sidebar'
const Layout = ({ children = 'No Content' }) => {
	const dispatch = useDispatch()
	const [isLargeWindow, setIsLargeWindow] = useState(false)
	const collapsed = useSelector(state => state?.ui?.sidebarCollapsed)
	const sidebarWidth = useMemo(
		() => (collapsed && !isLargeWindow ? '0px' : '280px'),
		[collapsed, isLargeWindow]
	)
	useEffect(() => {
		const initSidebar = () => {
			const collapsed = localStorage.getItem('sidebar-collapsed')
			const sidebarCollapsed = !!JSON.parse(collapsed)
			store.dispatch(toggleSidebar(sidebarCollapsed))
		}
		initSidebar()
	}, [])

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth >= 1280) {
				setIsLargeWindow(true)
				dispatch(toggleSidebar(!collapsed))
			} else {
				setIsLargeWindow(false)
			}
		}

		handleResize()
		window.addEventListener('resize', handleResize)

		return () => window.removeEventListener('resize', handleResize)
	}, [])

	useEffect(() => {
		const setHeight = () => {
			document.documentElement.style.setProperty(
				'--vh',
				`${window.innerHeight * 0.01}px`
			)
		}
		setHeight()
		window.addEventListener('resize', setHeight)
		return () => window.removeEventListener('resize', setHeight)
	}, [])
	return (
		<LayoutWrapper>
			<div className='h-[calc(var(--vh,1vh)*100-70px)] sm:h-[100vh] sm:max-h-[100vh] max-w-full w-full'>
				<div className='h-[70px] w-full bg-[#ffffff] dark:bg-[#2E2D2D]'>
					<Header isLargeWindow={isLargeWindow} />
				</div>
				<div className='h-[calc(var(--vh,1vh)*100-70px)] sm:h-[calc(100vh-70px)] w-full flex relative'>
					<div
						className='h-full max-h-full absolute z-40 xl:relative duration-300'
						style={{
							maxWidth: sidebarWidth,
							width: sidebarWidth,
						}}
					>
						<div className='bg-[#ffffff] dark:bg-[#2E2D2D] w-full h-full border-r border-[#e5e7eb] dark:border-[#545454]'>
							<Sidebar isLargeWindow={isLargeWindow} />
						</div>
					</div>
					<div className='h-full w-full xl:w-[calc(100%-280px)] max-h-full duration-300'>
						<div className='bg-[#f5f5f8] dark:bg-[#222222] w-full h-full overflow-auto'>
							{children}
						</div>
					</div>
				</div>
			</div>
		</LayoutWrapper>
	)
}
Layout.propTypes = {
	children: any,
}
export default Layout
